import { _SET_CREDIT_CODE_VALUE } from "./mutations"

export const SET_CREDIT_CODE_VALUE = "setCreditCodeValue"

export default {
  [SET_CREDIT_CODE_VALUE]({ commit }, creditCodeValue: number) {
    commit(_SET_CREDIT_CODE_VALUE, creditCodeValue)
  }
}
